import UAParser from 'ua-parser-js'

export function parseUserAgent(userAgent?: string): UAParser.IResult {
    const parser = new UAParser(userAgent)
    return parser.getResult()
}
